import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatchSummary } from '../../../../models/patch-management.models';

@Component({
  selector: 'app-devices-in-cycle-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './devices-in-cycle-card.component.html',
  styleUrls: ['./devices-in-cycle-card.component.scss'],
})
export class DevicesInCycleCardComponent {
  @Input({ required: true }) summary!: PatchSummary;
  /** Currently active 'Installed' | 'Missing' | null — matches the `status` filter field */
  @Input() activeStatus: string | null = null;
  @Output() statusSelect = new EventEmitter<string>();
}
